import React, { useEffect, useState } from 'react';
import './availableFunctionalitySection.scss';
import AvailableFunctionalityItemComponent from "./components/AvailableFunctionalityItemComponent";
import { ReactComponent as CopyTradingIcon } from "./icons/CopyTradingIcon.svg";
import { ReactComponent as LPSniperIcon } from "./icons/LPSniperIcon.svg";
import { ReactComponent as TakeProfitIcon } from "./icons/TakeProfitIcon.svg";
import { ReactComponent as MEVProtectIcon } from "./icons/MEVProtectIcon.svg";
import { ReactComponent as ScrapperIcon } from "./icons/ScrapperIcon.svg";

const AvailableFunctionalitySection = () => {
	const [width, setWidth] = useState(window.innerWidth);
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);
	
	return (
		<div className="availableFunctionality">
			<div className="availableFunctionality__content">
				<div className="availableFunctionality__content_title">
					<h2>Available functionality{width < 425 && <br/>} of trading bots</h2>
					<span>Our bots have all the features you need for successful on-chain trading. Learn about all the advantages that NFD Trade Bots can offer you.</span>
				</div>
				<div className="availableFunctionality__content_cards">
					<div className="availableFunctionality__content_cards_bg1"></div>
					<div className="availableFunctionality__content_cards_bg2"></div>
					<div className="availableFunctionality__content_cards_row">
						<AvailableFunctionalityItemComponent
							icon={<CopyTradingIcon />}
							class={"copyTrading"}
							title={"Copy Trading"}
							description={"Automatically copies actions of tracked wallets with fine-tuning for lightning-fast transactions."}
						/>
						<AvailableFunctionalityItemComponent
							icon={<LPSniperIcon />}
							class={"lpSniper"}
							title={"LP Sniper"}
							description={"Buy or sell tokens within the first seconds after liquidity migration from the launchpad to the DEX."}
						/>
						<AvailableFunctionalityItemComponent
							icon={<TakeProfitIcon />}
							class={"takeProfit"}
							title={"Stop Loss and Take Profit"}
							description={"Stop Loss and Take Profit will free you from monitoring the chart. The bot will do everything for you."}
						/>
					</div>
					<div className="availableFunctionality__content_cards_row">
						<AvailableFunctionalityItemComponent
							icon={<MEVProtectIcon />}
							class={"mevProtect"}
							title={"MEV Proteсt and Custom PRC"}
							description={"The bot's functionality supports custom RPCs and includes the MEV Protect feature to prevent losses from MEV."}
						/>
						<AvailableFunctionalityItemComponent
							icon={<ScrapperIcon />}
							class={"scrapper"}
							title={"Scrapper"}
							description={"Automatic purchase of tokens published in the Twitter and Telegram profiles you are interested in."}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AvailableFunctionalitySection;